import styled, { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Sora', sans-serif;
    scroll-behavior: smooth;
  }

  body {
    background: ${({ theme }) => theme.colors.background};
    font-size: 16px;
  }

  button {
    cursor: pointer;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s !important;
    -webkit-transition: background-color 5000s ease-in-out 0s !important;
    -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
    box-shadow: 0 0 0px 1000px #fff inset !important;
    -webkit-text-fill-color: #000 !important;
    color: #000 !important;
  }

  .ant-input:-webkit-autofill,
  .ant-input:-webkit-autofill:hover,
  .ant-input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px ${({ theme }) => theme.colors.background} inset !important;
    -webkit-text-fill-color: ${({ theme }) => theme.colors.primaryText} !important;
  }
`;

export const GridWrapper = styled.div`
  width: 100%;

  --ag-background-color: ${({ theme }) => theme.colors.secondary};
  --ag-foreground-color: ${({ theme }) => theme.colors.primaryText};
  --ag-header-background-color: ${({ theme }) => theme.colors.secondary};
  --ag-border-color: ${({ theme }) => theme.colors.borderColor};

  .ag-root-wrapper {
    border: none;
  }
`;
